import React, { useRef, useState } from "react";

const shortsData = [
  {
    id: 1,
    // title: "Silver Jewellery 🔥",
    src: "https://www.youtube.com/embed/N1n7v3VZrqU?autoplay=1&mute=1&loop=1&playlist=N1n7v3VZrqU",
  },
  {
    id: 2,
    // title: "Bridal Jewellery",
    src: "https://www.youtube.com/embed/zNv-5-5Me8o?autoplay=1&mute=1&loop=1&playlist=zNv-5-5Me8o",
  },
  {
    id: 3,
    // title: "Wear Jewellery",
    src: "https://www.youtube.com/embed/qYa2UOdIraA?autoplay=1&mute=1&loop=1&playlist=qYa2UOdIraA",
  },
    {
    id: 4,
    // title: "Wear Jewellery",
    src: "https://youtube.com/shorts/kUgBDioz-Tk?si=k6iZ9Ea2Xm-Ho8-x",
  },
     {
    id: 5,
    // title: "Wear Jewellery",
    src: "https://youtube.com/shorts/1Ojri08c1Uc?si=gZ8csmmzYM8VYU5-",
  },
     {
    id: 6,
    // title: "Wear Jewellery",
    src: "https://youtube.com/shorts/DygsJc8whH8?si=f08dq7UHYuFbm6JJ",
  },
     {
    id: 7,
    // title: "Wear Jewellery",
    src: "https://youtube.com/shorts/m85V0mXN5BM?si=1JU3cWrHwLTJo1W0",
  },
     {
    id: 8,
    // title: "Wear Jewellery",
    src: "https://youtube.com/shorts/L_709JNb1pA?si=H4albfnjK6TxbZQ8",
  }
];

// helper: src me mute=0 / mute=1 set kare
const setMuteInSrc = (src, muteValue) => {
  if (src.includes("mute=")) {
    return src.replace(/mute=\d/, `mute=${muteValue}`);
  }
  const hasQuery = src.includes("?");
  return src + (hasQuery ? "&" : "?") + `mute=${muteValue}`;
};

const YouTubeShortsSection = () => {
  const rowRef = useRef(null);
  const iframeRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleVideoClick = (index) => {
    setActiveIndex((prevActiveIndex) => {
      // same card dobara click → sab mute
      const newActiveIndex = prevActiveIndex === index ? null : index;

      iframeRefs.current.forEach((frame, i) => {
        if (!frame) return;

        const baseSrc = shortsData[i].src;
        const targetSrc =
          i === newActiveIndex
            ? setMuteInSrc(baseSrc, 0) // active → unmute
            : setMuteInSrc(baseSrc, 1); // baaki sab → mute

        // bar-bar reload avoid karne ke liye
        if (frame.src !== targetSrc) {
          frame.src = targetSrc;
        }
      });

      return newActiveIndex;
    });
  };

  const scrollRow = (direction) => {
    const container = rowRef.current;
    if (!container) return;

    const firstCard = container.querySelector(".yt-shorts-card");
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 180;

    container.scrollBy({
      left: direction === "left" ? -cardWidth * 2 : cardWidth * 2,
      behavior: "smooth",
    });
  };

  return (
    <div className="yt-shorts-wrapper">
      <div className="yt-shorts-header">
        <div className="yt-shorts-title-left">
          <div className="yt-shorts-icon">
            <span className="yt-shorts-icon-inner" />
          </div>
          <span className="yt-shorts-text">Shorts</span>
        </div>

        <div className="yt-shorts-header-right">
          <button
            className="yt-shorts-icon-btn"
            onClick={() => scrollRow("left")}
          >
            ‹
          </button>
          <button
            className="yt-shorts-icon-btn"
            onClick={() => scrollRow("right")}
          >
            ›
          </button>
        </div>
      </div>

      <div className="yt-shorts-row" ref={rowRef}>
        {shortsData.map((short, index) => {
          const isActive = activeIndex === index;
          return (
            <div
              key={short.id}
              className="yt-shorts-card"
              onClick={() => handleVideoClick(index)}
            >
              <div className="yt-shorts-thumb-wrapper">
                <iframe
                  ref={(el) => (iframeRefs.current[index] = el)}
                  className="yt-shorts-thumb"
                  src={short.src}
                  // title={short.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  playsInline
                ></iframe>

                <div className="yt-sound-icon">{isActive ? "🔊" : "🔇"}</div>
              </div>
              <div className="collection-title "><span className="collection-title-bg px-3 py-1 rounded-pill text-center">{short.title}</span></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YouTubeShortsSection;
